import React, { useState } from 'react'
import Button from '../button'
import Modal from './modal'
import classNames from 'classnames'

function DoYouWantToModal({
  isOpen,
  closeModal,
  refresh,
  title,
  subtitle,
  id,
  buttonText,
  btnFunction,
  type = 'delete',
  loading = false,
}) {
  return (
    <Modal
      scrollable={true}
      className='!max-w-[500px] !rounded-none'
      isOpen={isOpen}
      centered={true}
    >
      <div className='p-4 mb-10 overflow-auto'>
        <div className='flex flex-col overflow-auto justify-center'>
          <div className='flex flex-col md:mx-14 items-center justify-center'>
            <span className='text-center mt-2 header-4'>{title}</span>
            {subtitle && (
              <span className='text-center mt-2 mb-2 text-[13px]'>
                {subtitle}
              </span>
            )}
            <div className='flex flex-row justify-center w-full mt-[20px] gap-4'>
              <Button
                text={'Cancel'}
                type='button'
                theme={'secondary'}
                className='flex gap-2 h-[35px] w-fit p-2 '
                textClass={'!text-[13px]'}
                onClick={() => closeModal()}
              />
              <Button
                text={buttonText}
                type='button'
                loading={loading}
                className={classNames('flex gap-2 !h-[35px] w-fit p-2', {
                  '!bg-red-500': type === 'delete',
                })}
                textClass={'!text-[13px] '}
                onClick={() => btnFunction(id)}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default DoYouWantToModal
